import * as THREE from 'three';

export let scene, group;

export const SetupScene = () => {
    const _scene = new THREE.Scene();
    const _group = new THREE.Object3D();
    _scene.name = 'H9';
    _group.name = 'Whole Group';
    _scene.add(_group);

    setBackground(_scene);

    scene = _scene;
    group = _group;
};

const setBackground = (scene) => {
    scene.fog = new THREE.Fog(0xE1E9F6, 2.5, 4);
}